<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <div class='h-inputBox'>
          <ejs-textbox v-model='keyword' :placeholder='$t("Monitor.task.taskName")' @keyup.enter.native="filterMonitorTask" maxLength='20'></ejs-textbox>
        </div>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="monitorTaskData" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight" :allowExcelExport='true' >
          <e-columns>
            <e-column type="checkbox" width="50" textAlign="center"></e-column>
            <e-column field="id" :visible="false"></e-column>
            <e-column field="taskName" :headerText="$t('Monitor.task.taskName')" width="120" textAlign="Center"></e-column>
            <!--<e-column field="product" :headerText="$t('Monitor.task.product')" width="120" textAlign="Center"></e-column>-->
            <e-column field="sampleStart" :headerText="$t('Monitor.task.sampleStart')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="sampleEnd" :headerText="$t('Monitor.task.sampleEnd')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="exeState" :headerText="$t('Monitor.task.exeState')" :formatter='exeStateFormat' width="120" textAlign="Center"></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize="pageSettings.pageSize"
          :pageCount="page.pageCount"
          :currentPage="page.pageNo"
          :totalRecordsCount="page.totalRecordsCount"
          @click="getMonitorTaskList"
        ></ejs-pager>
      </div>
      <CustomDialog ref="addMonitorTaskDialog" v-bind:element="addDialog.element" v-bind:styles="addDialog.styles" >
        <template v-slot:dialog-content>
          <AddMonitorTask ref="addMonitorTaskPage"></AddMonitorTask>
        </template>
      </CustomDialog>
      <CustomDialog ref="showMonitorTaskDialog" v-bind:element="editDialog.element" v-bind:styles="editDialog.styles" >
        <template v-slot:dialog-content>
          <ShowMonitorTask ref="showMonitorTaskPage"></ShowMonitorTask>
        </template>
      </CustomDialog>
      </template>
  </BasicLayout>
</template>
<script>
import CustomDialog from "../../components/common/CustomDialog";
import BasicLayout from '../../layouts/BasicLayout';
import AddMonitorTask from './monitorTask/addMonitorTask';
import ShowMonitorTask from './monitorTask/showMonitorTask';
import {ExcelExport} from '@syncfusion/ej2-vue-grids';

export default {
  name: 'monitorTask',
  provide: {
    grid: [ExcelExport]
  },
  components: {
    CustomDialog,
    BasicLayout,
    AddMonitorTask,
    ShowMonitorTask,
  },
  data() {
    return {
      monitorTaskData: [],
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Monitor.monitor')}` + '/' + `${this.$t('Monitor.task.titleName')}` },
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-add', tooltipText: this.$t('Security.add'), click: this.showAddDialog },
        { prefixIcon: 'icon hero-icon hero-icon-start-up', tooltipText: this.$t('Pm.startUp'), click: this.activeMonitorTask },
        { prefixIcon: 'icon hero-icon hero-icon-disable', tooltipText: this.$t('System.deactiveTask'), click: this.deactiveMonitorTask },
        { prefixIcon: 'icon hero-icon hero-icon-edit', tooltipText: this.$t('Track.detail'), click: this.showEditDialog },
        { prefixIcon: 'icon hero-icon hero-icon-remove', tooltipText: this.$t('Security.delete'), click: this.deleteMonitorTask },
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid },
      ],
      keyword: '',
      pageSettings: { pageSize: 15 },
      page: {
        pageCount: 4,
        totalRecordsCount: 0,
        pageNo: 1,
      },
      dateFormat: {
        type: 'date', format: 'yyyy-MM-dd HH:mm:ss'
      },
      addStatus: true,
      addDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'addMonitorTaskDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.addMonitorTask,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ],
          title: `${this.$t('Pm.addMonitorTask')}`
        },
        styles: {
          width: '860px',
          height: '700px',
          model: true,
          visible: false
        }
      },
      editDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'showMonitorTaskDialog',
          buttonGroup: [
            {
              click: this.modiyMonitorTask,
              buttonModel: {content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            },

            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.close')}` }
            },
          ],
          title: `${this.$t('Pm.updateMonitorTask')}`
        },
        styles: {
          width: '860px',
          height: '700px',
          model: true,
          visible: false
        }
      },
      screenHeight: document.body.clientHeight - 240
    };
  },
  mounted() {
    this.getMonitorTaskList();
    let That = this;
  },
  methods: {
    exeStateFormat(grids, data) {
      if(data.exeState == 0){
        return `${this.$t('Monitor.task.notStarted')}`;
      }else if(data.exeState == 1){
        return `${this.$t('Monitor.task.inUse')}`;
      }else if(data.exeState == 2){
        return `${this.$t('Monitor.task.exeFinish')}`;
      }else if(data.exeState == 3){
        return `${this.$t('System.deactiveTask')}`;
      }
    },
    getMonitorTaskList() {
      const url = '/lte/ems/sys/monitor/task/query';
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = { params: {
        taskName: this.keyword,
        pageNo: this.page.pageNo,
        pageSize: this.pageSettings.pageSize
      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        result.forEach((v) => {
          if (!!v.sampleStart) {
            let date = new Date();
            date.setTime(v.sampleStart);
            v.sampleStart = date;
          }
          if (!!v.sampleEnd) {
            let date = new Date();
            date.setTime(v.sampleEnd);
            v.sampleEnd = date;
          }
        });
        That.monitorTaskData = result;
        That.page.totalRecordsCount = response.data.totalCount;
      });
    },
    filterMonitorTask() {
      this.getMonitorTaskList();
    },
    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    showAddDialog() {
      this.$refs.addMonitorTaskPage.init();
      this.$refs.addMonitorTaskDialog.show();
    },
    showEditDialog() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
       for(let i=0; i<record.length; i++){
        if(1== record[i].exeState){
          this.$parent.showToast('warning',`${this.$t('Monitor.task.activeMonitor')}`);
          return null;
        }
      }
      this.editId = record[0].id;
      this.$refs.showMonitorTaskPage.init(this.editId);
      this.$refs.showMonitorTaskDialog.show();
    },
    activeMonitorTask() {
      const url = "/lte/ems/sys/monitor/task/active";
      let record = this.getRecord();
      if (record == null) {
        return null;
      }
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      for(let i=0; i<record.length; i++){
        if(3 !== record[i].exeState){
          this.$parent.showToast('warning',`${this.$t('Monitor.task.activeMonitor')}`);
          return null;
        }
      }

      for(let i=0; i<this.monitorTaskData.length; i++){
        if(1 == this.monitorTaskData[i].exeState){
          this.$parent.showToast('warning',`${this.$t('Monitor.task.oneActiveMonitor')}`);
          return null;
        }
      }
      let That = this;
      const params = [];
      record.forEach((r, i) => {
        params.push(r.id);
      });
      var currentDate = new Date();
      if (currentDate > record[0].sampleEnd) {
        That.$parent.showToast('error',  `${this.$t('Common.tips.taskExpired')}`);
        return null;
      }
      this.axios.post(url, params).then(response => {
        const result = response.data;
        if(result){
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getMonitorTaskList();
        }else{
          That.$parent.showToast('error',  `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    deactiveMonitorTask() {
      const url = "/lte/ems/sys/monitor/task/deactive";
      let record = this.getRecord();
      if (record == null) {
        return null;
      }
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      for(let i=0; i<record.length; i++){
        if(1 !== record[i].exeState){
          this.$parent.showToast('warning',`${this.$t('Monitor.task.deactiveMonitor')}`);
          return null;
        }
      }
      let That = this;
      const params = [];
      record.forEach((r, i) => {
        params.push(r.id);
      });
      this.axios.post(url, params).then(response => {
        const result = response.data;
        if(result){
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getMonitorTaskList();
        }else{
          That.$parent.showToast('error',  `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    deleteMonitorTask() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      for(let i=0; i<record.length; i++){
        if(1 === record[i].exeState){
          this.$parent.showToast('warning',`${this.$t('Monitor.task.deleteMonitor')}`);
          return null;
        }
      }
      const url = '/lte/ems/sys/monitor/task/delete';
      const params = [];
      record.forEach((r, i) => {
        params.push(r.id);
      });
      let That = this;
      this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmTip')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            That.axios.post(url, params).then(response => {
              if (response.data) {
                That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
                That.getMonitorTaskList();
              } else {
                That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
              }
            });
          }
        }
      });
    },
    addMonitorTask() {
      let status = this.$refs.addMonitorTaskPage.validation();
      if(!status){
        return;
      }
      const url = '/lte/ems/sys/monitor/task/add';
      const monitorTaskPo = this.$refs.addMonitorTaskPage.getMonitorTask();
      console.log("******addMonitorTask-monitorTaskPo:", monitorTaskPo)

      if(monitorTaskPo == null) {
        return;
      }
      let That = this;
      this.axios.post(url, monitorTaskPo).then(response => {
        const result = response.data;
        if(result) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getMonitorTaskList();
          That.$refs.addMonitorTaskDialog.clear();
          That.$refs.addMonitorTaskDialog.close();
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    modiyMonitorTask() {
      let status = this.$refs.showMonitorTaskPage.validation();
      if(!status){
        return;
      }
      const url = '/lte/ems/sys/monitor/task/modify';
      const monitorTaskPo = this.$refs.showMonitorTaskPage.getMonitorTask();
      console.log("******modiyMonitorTask-monitorTaskPo:", monitorTaskPo)

      if(monitorTaskPo == null) {
        return;
      }
      let That = this;
      this.axios.post(url, monitorTaskPo).then(response => {
        const result = response.data;
        if(result) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getMonitorTaskList();
          That.$refs.showMonitorTaskDialog.clear();
          That.$refs.showMonitorTaskDialog.close();
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    dialogHide() {
      this.$refs.addMonitorTaskDialog.clear();
      this.$refs.addMonitorTaskDialog.close();
      this.$refs.showMonitorTaskDialog.clear();
      this.$refs.showMonitorTaskDialog.clear();
    },
    refreshGrid() {
      this.keyword='';
      this.getMonitorTaskList();
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        // EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        this.$parent.showToast('warning',`${this.$t('Alarm.no_checked')}`);

        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        // EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return false;
      }
      return selectedRecords;
    },
  },
  watch: {
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>
